import { useState, useMemo, useEffect } from "preact/hooks";
import { Label, Table } from "../../../bpmn.io/@bpmn-io/form-js-viewer";
import classNames from "../../../bpmn.io/classnames";
import{ html } from 'htm/preact';
import { AppData } from "../../helpers/app-data";

function _bspEnsureSpinnerStyle() {
  if (!document.getElementById('_bsp-spin-style')) {
    const s = document.createElement('style');
    s.id = '_bsp-spin-style';
    s.textContent = '@keyframes _bspSpin{to{transform:rotate(360deg)}}';
    document.head.appendChild(s);
  }
}
function _bspCreateSpinner() {
  const wrap = document.createElement('div');
  wrap.style.cssText = 'display:flex;align-items:center;justify-content:center;height:120px;width:100%;';
  const ring = document.createElement('div');
  ring.style.cssText = 'width:48px;height:48px;border:5px solid #e0e0e0;border-top-color:#0078d4;border-radius:50%;animation:_bspSpin 0.8s linear infinite;';
  wrap.appendChild(ring);
  return wrap;
}

export const typeBSP = "datatablearchivosbsp";

export function FeedbackTableBSPRenderer(props) {
  const { disabled, readonly, field } = props;
  const { message } = field;

  const { columnsExpression, columns = [], id, label } = props.field;
  const shouldUseMockColumns =
    (typeof columnsExpression === "string" && columnsExpression.length > 0) ||
    (Array.isArray(columns) && columns.length === 0);

  const editorColumns = shouldUseMockColumns
    ? [
        { key: "1", label: "Column 1" },
        { key: "2", label: "Column 2" },
        { key: "3", label: "Column 3" },
      ]
    : columns;

  const prefixId = `fjs-form-${id}`;

  const [data, setData] = useState([]);
  const [serviceColumns, setServiceColumns] = useState([]);
  const visibleColumns = ["NombreDocumento"];
  const AditionalColumns = [{'label': 'Aprobado', 'controlType': 'checkBox', 'position': 0}, {'label': 'Observaciones', 'controlType': 'textBox', 'position': -1}];
  const [isButtonVisible, setIsButtonVisible] = useState(true); // Estado para controlar la visibilidad del botón

  function updateGlobalData(data) {
    window.globalData = data;
    if (window.onGlobalDataUpdate) {
      window.onGlobalDataUpdate(data);
    }
  }

  // Asignar la función al objeto global window para que pueda ser accedida globalmente
  window.updateGlobalData = updateGlobalData;

  // Function to fetch data
  const fetchData = (idEjecucion) => {
    const API_TOKEN = sessionStorage.getItem(AppData.localStorageToken);
    if (!API_TOKEN) {
      console.error("API token not found");
      return;
    }

    const url = `${AppData.API_URL}EjecucionProceso/DocumentosEjecucionProceso?IdEjecucion=${idEjecucion}`;
    /* const url = `${AppData.API_URL}EjecucionProceso/DocumentosEjecucionProceso?IdEjecucion=9`; */
    const headers = {
      "Content-Type": "application/json",
      "X-APIKey": AppData.API_KEY,
      Authorization: `Bearer ${API_TOKEN}`,
    };

    fetch(url, {
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((responseData) => {
        
        if (responseData.Data.length > 0) {
          const firstItem = responseData.Data[0];
          const columns = Object.keys(firstItem)
            .filter((key) => visibleColumns.includes(key))
            .map((key) => ({
              key,
              label: key.charAt(0).toUpperCase() + key.slice(1),
            }));

          if(AditionalColumns)
          {
            AditionalColumns.forEach(column => {
              if(column.position == 0)
              {
                columns.splice(0,0,{ key: column.label, label: column.label});
              }
              else
              {
                columns.push({ key: column.label, label: column.label});
              }
            })
          }

          responseData.Data.forEach(item => {
            item['Aprobado'] = false;
            item['Observaciones'] = '';
          })

          setServiceColumns(columns);
        }
        updateGlobalData(responseData.Data);
        setData(responseData.Data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };

  useEffect(() => {
    const baseService = window.baseService;
    if (baseService) {
      const subscription = baseService.currentTablaArchivosVisible.subscribe(
        (isVisible) => {
          if (!isVisible) {
            setIsButtonVisible(isVisible);
          }
        }
      );
      const subscriptionData = baseService.currentIdEjecucionProceso.subscribe(
        (idEjecucionProceso) => {
          if (idEjecucionProceso) {
            fetchData(idEjecucionProceso);
          } 
        }
      );

      return () => {subscription.unsubscribe(), subscriptionData.unsubscribe()};

    }
  }, []);


  async function descargarDocumentoGeneral(idArchivo, NombreDocumento) {
    const API_TOKEN = sessionStorage.getItem(AppData.localStorageToken); 
    const headers = {
      "Content-Type": "application/json",
      "X-APIKey": AppData.API_KEY,
      Authorization: `Bearer ${API_TOKEN}`,
      Accept: "application/octet-stream",
    };
  
    try {
      const response = await fetch(
        `${AppData.API_URL}EjecucionProceso/ConsultarDocumentoBSP?IdDocumentoEjecucion=${idArchivo}`,
        {
          method: "GET",
          headers: headers,
        }
      );
  
      if (!response.ok) {
        throw new Error("Error en la respuesta de la red");
      }
  
      const jsonDoc = await response.json();

      if(jsonDoc.Data)
      {   
        let results = await axios({
          url: jsonDoc.Data,
          method: 'GET',
          responseType: 'blob'
        })
        // Crear un enlace para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([results.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = NombreDocumento;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a); // Remover el enlace del DOM
        const _dcEl1 = document.getElementById('documentContent');
        if (_dcEl1) { _dcEl1.innerHTML = ''; _dcEl1.style.display = 'none'; }
      }
      else
      {
        const _dcEl2 = document.getElementById('documentContent');
        if (_dcEl2) { _dcEl2.innerHTML = ''; _dcEl2.style.display = 'none'; }
      }


      
     
    } catch (error) {
      console.error("Error descargando el documento", error);
    }
  }

  const setApprobalDocument = (id) => {
    
    let test = data.filter(x => x.Id == id);
    const _aprobEl = document.getElementById('Aprob_' + id);
    test[0]['Aprobado'] = _aprobEl ? _aprobEl.checked : false;

    updateGlobalData(data);
  };

  const setObsDocument = (id) => {
    
    let test = data.filter(x => x.Id == id);
    const _obsEl = document.getElementById('Obs_' + id);
    test[0]['Observaciones'] = _obsEl ? _obsEl.value : '';

    updateGlobalData(data);
  };

  const handleOpenDocument = (id) => {
    
    const API_TOKEN = sessionStorage.getItem(AppData.localStorageToken);
    const url = `${AppData.API_URL}EjecucionProceso/ConsultarDocumentoBSP?IdDocumentoEjecucion=${id}`;
    const headers = {
      "Content-Type": "application/json",
      "X-APIKey": AppData.API_KEY,
      Authorization: `Bearer ${API_TOKEN}`,
      Accept: "application/octet-stream",
    };

    fetch(url, {
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((responseData) => {
      //.then((blob) => {
        
        if(responseData.Data)
        {
          const blobUrl = responseData.Data;
          const _extUrl2 = blobUrl.toLowerCase().replace(/\?.*$/, '');
          // Archivos comprimidos: sin visor disponible en el navegador → descargar directamente
          if (/\.(zip|rar|7z)$/.test(_extUrl2)) {
            const _dlA2 = document.createElement('a');
            _dlA2.href = blobUrl;
            _dlA2.download = blobUrl.split('/').pop()?.split('?')[0] || 'archivo';
            _dlA2.target = '_blank';
            _dlA2.style.display = 'none';
            document.body.appendChild(_dlA2);
            _dlA2.click();
            document.body.removeChild(_dlA2);
            const _dcZip2 = document.getElementById('documentContent');
            if (_dcZip2) {
              _dcZip2.innerHTML = '<p style="padding:1em;color:#555;">Archivo comprimido — la descarga ha iniciado.</p>';
              _dcZip2.style.display = 'block';
            }
            return;
          }
          let _viewerEl2;
          if (/\.(png|jpe?g|gif|webp|svg|bmp|ico)$/.test(_extUrl2)) {
            _viewerEl2 = document.createElement('img');
            _viewerEl2.style = 'max-width: 100%; max-height: 30em; display: block; margin: auto; padding: 1em;';
            _viewerEl2.src = blobUrl;
          } else {
            _viewerEl2 = document.createElement('iframe');
            _viewerEl2.style = 'width: 100%; height: 30em; padding: 2em; border: none;';
            if (/\.(xlsx?|docx?|pptx?|csv)$/.test(_extUrl2)) {
              _viewerEl2.src = 'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(blobUrl);
            } else if (/\.(pdf|txt|html?|xml)$/.test(_extUrl2)) {
              _viewerEl2.src = blobUrl;
            } else {
              _viewerEl2.src = 'https://docs.google.com/gview?url=' + encodeURIComponent(blobUrl) + '&embedded=true';
            }
          }
          const _dcEl3 = document.getElementById('documentContent');
          if (_dcEl3) {
            _dcEl3.innerHTML = '';
            _bspEnsureSpinnerStyle();
            const _sp2 = _bspCreateSpinner();
            _dcEl3.appendChild(_sp2);
            _dcEl3.style.display = 'block';
            _viewerEl2.onload = () => _sp2.remove();
            _dcEl3.appendChild(_viewerEl2);
          }
        }
        else
        {
          const _dcEl4 = document.getElementById('documentContent');
          if (_dcEl4) _dcEl4.style.display = 'none';
        }

        //window.open(blobUrl, "_blank");
      })
      .catch((error) => {
        console.error("Error fetching document: ", error);
      });
  };

  
  
    return html`
      <div class=${editorFormFieldClasses("table", { disabled: true })}>
        <label id=${prefixId} label=${label} />
        <div class="fjs-table-middle-container">
          <div class="fjs-table-inner-container">
            <table
              class=${classNames("fjs-table", "fjs-disabled")}
              id=${prefixId}
            >
              <thead class="fjs-table-head">
                <tr class="fjs-table-tr">
                  ${(serviceColumns.length > 0
                    ? serviceColumns
                    : editorColumns
                  ).map(
                    (column) => html`
                      <th class="fjs-table-th" key=${column.key}>
                        ${column.label}
                      </th>
                    `
                  )}
                  <th class="fjs-table-th">Acción</th>
                </tr>
              </thead>
              <tbody class="fjs-table-body">
                ${data.map(
                  (row, rowIndex) => html`
                    <tr class="fjs-table-tr docRow" key=${rowIndex}>
                      ${(serviceColumns.length > 0
                        ? serviceColumns
                        : editorColumns
                      ).map(
                        function(column) {

                        let dataBind = false;

                        for(const index in AditionalColumns){

                          if(AditionalColumns[index].label == column.key)
                          {
                            if(AditionalColumns[index].controlType == 'checkBox')
                            {
                              return html`
                              <td class="fjs-table-td">
                                <input type="checkbox" id="Aprob_${row.Id}" onChange=${() => setApprobalDocument(row.Id)}/>
                              </td>`;
                            }
                            else if(AditionalColumns[index].controlType == 'textBox')
                            {
                              return html`
                              <td class="fjs-table-td">
                                <textarea id="Obs_${row.Id}" rows="1" cols="25" onBlur=${() => setObsDocument(row.Id)}></textarea>
                              </td>`;          
                            }        
                          } 
                          else
                          {
                            dataBind = true;
                          }  

                        }
                        
                        if(dataBind)
                        {
                          return html`
                              <td class="fjs-table-td">
                                ${row[column.key]}
                              </td>`;  
                        }

                        } //getAddControl(column.key, row) 

                        
                      )}
                      <td class="fjs-table-td">
                        <button
                          class="ms-CommandButton-button"
                          type="button"
                          onClick=${() => handleOpenDocument(row.Id)}
                        >
                          <span
                            class="ms-CommandButton-icon ms-fontColor-themePrimary"
                            ><i class="ms-Icon ms-Icon--View"></i
                          ></span>
                        </button>

                        <button class="ms-CommandButton-button" type="button" onClick=${() => descargarDocumentoGeneral(row.Id, row.NombreDocumento)}>
                          <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Download"></i></span>
                         </button>

                      </td>
                    </tr>
                  `
                )}
              </tbody>
            </table>
          </div>
        </div>
        <p style="color: brown; display: none;" id='requiredObsError'></p>
      </div>
      <div id="documentContent" style="display:none;"></div>
    `;
  //}
}

FeedbackTableBSPRenderer.config = {
  ...Table.config,
  type: typeBSP,
  label: "Tabla Archivos BSP",
  iconUrl: ``,
  propertiesPanelEntries: ["label"],
};

export function editorFormFieldClasses(type, { disabled = false } = {}) {
  if (!type) {
    throw new Error("type required");
  }

  return classNames("fjs-form-field", `fjs-form-field-${type}`, {
    "fjs-disabled": disabled,
  });
}
